<script setup>
defineProps({
    msg: {
        type: String,
        default: "",
    }
});
</script>


<template>
    <Transition name="fade">
        <small class="text-danger text-small" v-if="msg">
            {{ msg }}
        </small>
    </Transition>
</template>

<style scoped>
.error-message-container {
  min-height: 1.7rem;
}

.fade-leave-to,
.fade-enter-from {
  opacity: 0;
}
.fade-leave-active,
.fade-enter-active {
  transition: opacity 0.3s ease;
}
</style>


